import gql from 'graphql-tag';

export const allowNoteTypeDelete = gql`
  query allowNoteTypeDelete($id: String) {
    allowNoteTypeDelete(id: $id) {
      value
    }
  }
`;
